import { TextField } from "@repo/design-system";
import { ExactMatchColumnsForFiltersForDTO } from "@/api/molecularData";
import { EXACT_MATCH_FIELD_CONFIG } from "@/lib/filterFieldConfig";
import type { ExactMatchDraft } from "../../../hooks";

const FIELD_ORDER = Object.values(ExactMatchColumnsForFiltersForDTO);

interface IExactMatchFieldsProps {
  exactMatch: ExactMatchDraft;
  onChange: (field: ExactMatchColumnsForFiltersForDTO, value: string) => void;
}

export function ExactMatchFields({
  exactMatch,
  onChange,
}: IExactMatchFieldsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {FIELD_ORDER.map((field) => {
        const config = EXACT_MATCH_FIELD_CONFIG[field];
        const value = exactMatch[field] ?? "";
        return (
          <TextField
            key={field}
            label={config.label}
            placeholder={config.placeholder}
            description={config.description}
            value={value}
            onChange={(next) => onChange(field, next)}
            clearable
            onClear={() => onChange(field, "")}
          />
        );
      })}
    </div>
  );
}
